import { getTypography } from '@creditas-ui/utilities';
import { styled, css, keyframes } from '@creditas-ui/system';

const navTextExpanded = ({ expanded = false }: { expanded?: boolean }) =>
  expanded &&
  css`
    width: auto;
    align-self: flex-start;
    margin: 0 auto;
  `;

export const Profile = styled.div`
  display: flex;
  width: 100%;
  padding: 0;
  margin-left: 9px;
`;

export const IconLogoWrapper = styled.div`
  width: 43px;
  height: 32px;
  overflow: hidden;
  transition: width 1.265s ease-out;
  ${navTextExpanded}
`;

export const Source = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  cursor: pointer;
  justify-content: space-between;
`;

export const ProfileLogo = styled.div``;

export const ProfileUser = styled.div`
  display: flex;
  flex-direction: column;
`;

const toggle = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

const profileTextExpanded = ({ expanded = false }: { expanded?: boolean }) =>
  expanded &&
  css`
    animation: ${toggle} 0.456s ease-out;
  `;

export const User = styled.div`
  padding-left: 9px;
  white-space: nowrap;
  ${profileTextExpanded}
`;

export const UserToggle = styled.div`
  padding-top: 10px;
  button {
    padding-top: 10px;
  }
`;

export const UserLoggoutButton = styled.button`
  border: none;
  background: transparent;
  ${getTypography('bodyMdLight')}
  cursor: pointer;
`;

export const Paragraph = styled.p``;
